export const CHECKOUT_URL = 'https://the-core-floor.impultienda.ar/checkout'

export const MAIN_MOCKUP =
  'https://cdn.magicpatterns.com/uploads/wFWN7FXgSvEQnXwr2PD4MC/MOCK_UP_PRINCIPAL.png'

export const HERO_SUB =
  'The complete step-by-step system to see clearly, break the emotional pull, prepare your next move, and rebuild your life.'

export const IMAGES = {
  /** Woman walking away while he asks her to come back — the decision is hers. */
  recognition:
    'https://cdn.magicpatterns.com/uploads/t6apRWAtVPEg9z1DieMkhH/ChatGPT_Image_8_sept_2026,_13_09_30.png',
  /** Sophisticated mother with her children — the new chapter. */
  power:
    'https://cdn.magicpatterns.com/uploads/kcyYgCmqMoi9ujwKpeUmU4/ChatGPT_Image_8_sept_2026,_12_03_59.png',
  /** The empowered woman / new life transformation. */
  autonomy:
    'https://cdn.magicpatterns.com/uploads/xhTUVkzkv7EpFRNxsG92Td/ChatGPT_Image_8_sept_2026,_11_58_39.png',
}

export const journeySteps: string[] = [
  'See Clearly',
  'Detach',
  'Prepare',
  'Protect',
  'Respond',
  'Rebuild',
]

export type Stat = { value: string; label: string }

export const stats: Stat[] = [
  { value: '+1,200', label: 'Women empowered' },
  { value: '6', label: 'Core volumes' },
  { value: '6', label: 'Exclusive bonuses' },
  { value: '4.9/5', label: 'Trust rating' },
]

export type Testimonial = {
  quote: string
  name: string
  location: string
  day: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'I organized my entire exit in a weekend. For the first time, I had an actual PLAN instead of just panic. The Stealth Logistics changed everything.',
    name: 'Sarah M.',
    location: 'California',
    day: 'Day 47',
  },
  {
    quote:
      'The Clarity chapter helped me see the patterns I was blind to. I stopped questioning whether I was overreacting. I knew exactly what I was looking at.',
    name: 'Jennifer T.',
    location: 'New York',
    day: 'Day 62',
  },
  {
    quote:
      'During the hardest moments, when I felt like I couldn\u2019t breathe, I had an actual tool. Not just advice. Real, practical tools that worked immediately.',
    name: 'Rebecca K.',
    location: 'Texas',
    day: 'Day 35',
  },
]

export const painLines: string[] = [
  'You rehearse what you\u2019re going to say before you say it.',
  'Seeing his name on your phone can change your entire mood.',
  'You\u2019ve promised yourself “never again” — and still gone back.',
  'You question your own memory of what happened.',
  'You\u2019ve searched late at night for answers you still don\u2019t have.',
  'You know something has to change. You just don\u2019t know how.',
]

export type Volume = { number: string; title: string; line: string }

export const volumes: Volume[] = [
  {
    number: 'Volume 1',
    title: 'The Reality Map',
    line: 'See the relationship clearly and recognize the patterns that kept you confused.',
  },
  {
    number: 'Volume 2',
    title: 'The Emotional Breakout',
    line: 'Break the emotional pull that keeps drawing you back.',
  },
  {
    number: 'Volume 3',
    title: 'The Invisible Logistics',
    line: 'Turn “I need to leave” into a practical plan.',
  },
  {
    number: 'Volume 4',
    title: 'The Mother\u2019s Shield',
    line: 'Protect your children through the transition.',
  },
  {
    number: 'Volume 5',
    title: 'The Communication Shield',
    line: 'Handle manipulation without being pulled back into the cycle.',
  },
  {
    number: 'Volume 6',
    title: 'The New Identity',
    line: 'Rebuild your self-worth, independence, and life.',
  },
]

export const systemIncludes: string[] = [
  'Step-by-step guidance',
  'Practical exercises & action plans',
  'Ready-to-use scripts',
  'Checklists & frameworks',
  'Tools for real-life situations',
  'A clear path from confusion to independence',
]

export type Bonus = {
  number: string
  title: string
  line: string
  value: string
  image: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The Clarity Journal',
    line: 'See the patterns you couldn\u2019t see before.',
    value: '$47',
    image:
      'https://cdn.magicpatterns.com/uploads/3wt7jsFVRWUDQDCgtBPe2b/MKUP_B1.png',
  },
  {
    number: '02',
    title: 'The Nervous System Reset',
    line: 'Simple tools for overwhelming emotional moments.',
    value: '$67',
    image:
      'https://cdn.magicpatterns.com/uploads/h7oDCAFrxpNJr1FH8Wokct/MKUP_B2.png',
  },
  {
    number: '03',
    title: 'The Evidence Vault',
    line: 'Organize and protect the information that matters.',
    value: '$97',
    image:
      'https://cdn.magicpatterns.com/uploads/bBtLdpTqGDXjQUsxfaRPrd/MKUP_B3.png',
  },
  {
    number: '04',
    title: 'The Family Dialogue Scripts',
    line: 'Know what to say when you can\u2019t find the words.',
    value: '$47',
    image:
      'https://cdn.magicpatterns.com/uploads/vbozKBG4xzbD67op1irW6d/MKUP_B4.png',
  },
  {
    number: '05',
    title: 'The Grey Rock Bible',
    line: '200 ready-to-use responses for difficult communication.',
    value: '$97',
    image:
      'https://cdn.magicpatterns.com/uploads/ezwiLP1eaCj6nEsJnLSy1u/MKUP_B5.png',
  },
  {
    number: '06',
    title: 'The 90-Day Fresh Start Tracker',
    line: 'Turn your new beginning into daily forward movement.',
    value: '$37',
    image:
      'https://cdn.magicpatterns.com/uploads/o19u4GFGo55dtYMGxpjPyE/MKUP_B6.png',
  },
]

export const offerItems: string[] = [
  '6 Core Volumes',
  '6 Exclusive Bonuses',
  'Instant Digital Access',
  'Lifetime Access',
]

export type CostRow = { situation: string; result: string }

export const costRows: CostRow[] = [
  {
    situation: 'Staying in the same cycle',
    result: 'More second-guessing yourself.',
  },
  {
    situation: 'Waiting for him to change',
    result: 'More promises. More hope. The same pattern.',
  },
  {
    situation: 'Living around his reactions',
    result: 'More decisions shaped by someone else\u2019s moods.',
  },
  {
    situation: 'Putting yourself last',
    result: 'Another year further away from the life you want.',
  },
]

export type Faq = { question: string; answer: string }

export const faqs: Faq[] = [
  {
    question: 'What if I\u2019m not ready to leave yet?',
    answer:
      'You\u2019re not committing to leaving today. You\u2019re committing to understanding clearly. The timeline happens when YOU\u2019RE ready.',
  },
  {
    question: 'What about my children?',
    answer:
      'Volume 4 (The Mother\u2019s Shield) covers age-appropriate communication and protecting their sense of safety. Bonus 4 gives you the exact words.',
  },
  {
    question: 'I don\u2019t have money. How am I supposed to leave?',
    answer:
      'Volume 3 (The Invisible Logistics) shows you how to build financial independence, organize resources and create a realistic timeline.',
  },
  {
    question: 'What if I have to stay in contact with him?',
    answer:
      'Volume 5 (The Communication Shield) is designed exactly for this — and Bonus 5 gives you 200+ ready-to-use responses.',
  },
  {
    question: 'What if I\u2019m afraid he\u2019ll discover what I\u2019m reading?',
    answer:
      'The material is designed to be discrete and private, with practical guidance on maintaining privacy while you prepare.',
  },
  {
    question: 'How do I receive it?',
    answer:
      'Instant PDF access, minutes after checkout. Lifetime digital access, on any device.',
  },
  {
    question: 'What if it isn\u2019t for me?',
    answer:
      'You\u2019re covered by the 7-day guarantee. Request your refund within 7 days.',
  },
]
